import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import RemoveIcon from '@material-ui/icons/Remove';
import '../../styles/faq.scss';
import Tablefaq from '../pages/Faq/Tablefaq';
import '../../styles/tablefaq.scss';
import '../../styles/tablerealestatefaq.scss';
import HowitworkfaqRealtor from '../pages/Faq/HowitworkfaqRealtor';
import TraditionalprocessfaqRealtor from './TraditionalprocessfaqRealtor';
import Howitworksrealestatefaq from '../pages/Faq/Howitworksrealestatefaq';
import Tablerealestatefaq from '../pages/Faq/Tablerealestatefaq';
import Myclientfaq from '../pages/Faq/Myclientfaq';
import Helpmerealestatefaq from '../pages/Faq/Helpmerealestatefaq';
import { useGAEventsTracker } from '../../util/gtag';

const Accordion = withStyles({
  root: {
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:first-child)': {
      borderTop: '1px solid rgba(0, 0, 0, .125)',
    },
    '&:not(:last-child)': {
      borderBottom: '1px solid rgba(0, 0, 0, .125)',
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    borderBottom: '0px solid #000',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function CustomizedAccordions(props) {
  const GAEventTracker = useGAEventsTracker(window.location.pathname)
  const GAEventTrackerHomeBuyerQue1 = useGAEventsTracker(window.location.pathname + "/Homebuyer/What is The Trade-In Mortgage™");
  const GAEventTrackerHomeBuyerQue2 = useGAEventsTracker(window.location.pathname + "/Homebuyer/How does it work");
  const GAEventTrackerHomeBuyerQue3 = useGAEventsTracker(window.location.pathname + "/Homebuyer/How much does The Trade-In Mortgage™ cost");
  const GAEventTrackerHomeBuyerQue4 = useGAEventsTracker(window.location.pathname + "/Homebuyer/How do I get started and apply for The Trade-In Mortgage™");
  const GAEventTrackerHomeBuyerQue5 = useGAEventsTracker(window.location.pathname + "/Homebuyer/Will I be out-of-pocket for two mortgage payments at once");
  const GAEventTrackerHomeBuyerQue6 = useGAEventsTracker(window.location.pathname + "/Homebuyer/How does The Trade-In Mortgage™ compare to the traditional process");
  const GAEventTrackerHomeBuyerQue7 = useGAEventsTracker(window.location.pathname + "/Homebuyer/How does The Trade-In Mortgage™ pricing compare to iBuyers or other buy-first solutions");
  const GAEventTrackerHomeBuyerQue8 = useGAEventsTracker(window.location.pathname + "/Homebuyer/What happens if my original house doesn’t sell within the specified timeframe on the open market");
  const GAEventTrackerHomeBuyerQue9 = useGAEventsTracker(window.location.pathname + "/Homebuyer/Are there any limits to the type of property I can try with The Trade-In Mortgage™");

  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState();
  const [open3, setOpen3] = React.useState();
  const [open4, setOpen4] = React.useState();
  const [open6, setOpen6] = React.useState(false);
  const [open7, setOpen7] = React.useState();
  const [open8, setOpen8] = React.useState(false);
  const [open9, setOpen9] = React.useState();
  const [open10, setOpen10] = React.useState();
  // <----------------------------Realestate-faq----------------------------->
  const [open11, setOpen11] = React.useState(false);
  const [open12, setOpen12] = React.useState();
  const [open13, setOpen13] = React.useState();
  const [open14, setOpen14] = React.useState();
  const [open15, setOpen15] = React.useState();
  const [open16, setOpen16] = React.useState();
  const [open17, setOpen17] = React.useState();
  const [open18, setOpen18] = React.useState();
  const [open19, setOpen19] = React.useState();
  const [open20, setOpen20] = React.useState();
  const [open21, setOpen21] = React.useState();
  const [open22, setOpen22] = React.useState();
  const [open23, setOpen23] = React.useState();

  const [showResults, setShowResults] = React.useState(true)
  const [showResultsTwo, setShowResultsTwo] = React.useState(false)
  const onClick = () => {
    GAEventTracker("Homebuyer", 1)
    setShowResults(true)
    setShowResultsTwo(false)
  }
  const onClickChange = () => {
    GAEventTracker("Real Estate Agent", 1)
    setShowResults(false)
    setShowResultsTwo(true)
  }
  const handleOpenFaq = () => {
    setOpen4(!open4)
    return (
      window.scrollTo(0,0)
    )
  }

  return (
    <div className="top-padding-medium bottom-padding-medium">
      <div className="d-flex justify-content-between py-4">
        <div>
          <h2 className="jost-bold">FAQs</h2>
        </div>
        <div id='wrapper' className="jost-medium">
          <span className="px-3" id="faq1" onClick={onClick} style={{ cursor: 'pointer' }}><span className={showResults === true ? "faq-tab-active" : 'inactive'}>Homebuyer</span></span><span className="px-3" id="faq2" ></span>
        </div>
      </div>
      {showResults === true ?
        <div>
          <Accordion
            style={{ borderTop: 'none' }}
          >
            <AccordionSummary aria-controls="panel1d-content"
              id="panel1d-header"
              onClick={(e) => { GAEventTrackerHomeBuyerQue1('FAQs/Questionnaire', 1); setOpen1(!open1) }}
              expandIcon={open1 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">What is The Trade-In Mortgage™?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                The Trade-In Mortgage™ is an innovative home loan product that enables homeowners to buy a new home before selling their current home. Lending partners offering The Trade-In Mortgage™ {(props?.pathname.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? 'write a loan on the new home using' : 'use a new process that allows you to use'} the equity you have in your current home before you even list it on the market. This simplifies and streamlines the home-buying process and reduces stress by: empowering you to submit competitive{(props?.partner?.url_path === "jw&!$329654" || props?.partner?.url_path === "jasonwalter") ? '' :', non-contingent'} offers that are like cash on new home prospects, buy and move into your new home before you sell your current one, and make repairs and prep your original home for sale after you have moved out so it always looks show-ready and sells for the best price. Throughout the program, you work with {(props?.pathname.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? 'your preferred real estate agent' : 'us'} to find and buy your new home as well as price, list, and show your original home so you have peace of mind that you are working with the best team possible. Our goal is to help you buy and sell your next home on your terms.
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              aria-controls="panel2d-content"
              id="panel2d-header"
              onClick={(e) => { GAEventTrackerHomeBuyerQue2('FAQs/Questionnaire', 1); setOpen2(!open2) }}
              expandIcon={open2 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How does it work?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                The Trade-In Mortgage™ makes the home purchase process more convenient and affordable and can be broken down into four simple and easy steps:
                <HowitworkfaqRealtor partner={props.partner} />
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTrackerHomeBuyerQue3('FAQs/Questionnaire', 1); setOpen3(!open3) }}
              expandIcon={open3 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How much does The Trade-In Mortgage™ cost?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
              {(props?.partner?.url_path === "jw&!$329654" || props?.partner?.url_path === "jasonwalter") ? 'The cost consists of three fees: $2,000 flat fee to Calque, 1% of the GBO to Calque, and a fee to the Calque lending partner that varies by lender and market. Many consumers actually experience cost savings compared to the traditional home buying process; your agents can help you negotiate a lower purchase price on your new home by leveraging a non-contingent offer, and for the small fee listed above, you avoid the potential costs of moving twice, short term rentals, and/or costly private mortgage insurance.' : 
              (props?.partner?.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? ' On average, The Trade-In Mortgage™ fee is approximately 1.5% of the purchase price of the original home in most markets. The cost consists of three fees: $2,000 flat fee to Calque, 1% of the GBO to Calque, and a fee to the Calque lending partner that varies by lender and market. Many consumers actually experience cost savings compared to the traditional home buying process; your agents can help you negotiate a lower purchase price on your new home by leveraging a non-contingent offer, and for the small fee listed above, you avoid the potential costs of moving twice, short term rentals, and/or costly private mortgage insurance.' : props?.partner?.url_path === 'warburton' ? 'The cost to use The Trade-In Mortgage™ is made up of three fees: $2,000 flat fee to Calque, 1% of the Guaranteed Backup Offer to Calque, and a variable second mortgage fee (if you choose to use the equity in your current home to make a down payment) that varies by transaction. Many consumers actually experience cost savings compared to the traditional home buying process. Most agents can help you negotiate a lower purchase price on your new home by leveraging a non-contingent offer, and for the small fee listed above, you avoid the potential costs of moving twice, short term rentals, and/or costly private mortgage insurance.' : ' On average, The Trade-In Mortgage™ fee is approximately 1.5% of the purchase price of the original home in most markets. However, many consumers actually experience cost savings compared to the traditional home buying process; our agents can often help you negotiate a lower purchase price on your new home by leveraging a non-contingent offer, and for the small fee listed above, you avoid the potential costs of moving twice, short term rentals, and/or costly private mortgage insurance.'}
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTrackerHomeBuyerQue4('FAQs/Questionnaire', 1); setOpen4(!open4) }}
              expandIcon={open4 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How do I get started and apply for The Trade-In Mortgage™?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                Click <span style={{ fontWeight: 'bolder', cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { handleOpenFaq(); props.handleReset() }}> here</span> to get started. The questionnaire should take less than 5 minutes to complete.
              </span>
            </AccordionDetails>
          </Accordion>

          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTrackerHomeBuyerQue5('FAQs/Questionnaire', 1); setOpen6(!open6) }}
              expandIcon={open6 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">Will I be out-of-pocket for two mortgage payments at once?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
              You will only pay two mortgages for a limited amount of time (up to 180 days in most markets). The Guaranteed Backup Offer (GBO) is a guaranteed backup contract on your original house so you will only pay the mortgage on that home until it sells on the open market or until Calque purchases the home per the GBO, whichever comes first. 
              <br></br><br></br>
              Importantly, all the mortgage payments you make on both homes go towards building your equity. In most states, you can use a second mortgage to tap the equity in your current home to make payments on that home; if you're interested in this option, please talk to your loan officer for more information. 
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTrackerHomeBuyerQue6('FAQs/Questionnaire', 1); setOpen7(!open7) }}
              expandIcon={open7 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How does The Trade-In Mortgage™ compare to the traditional process?</span>
            </AccordionSummary>
            <AccordionDetails style={{ marginLeft: '10px' }}>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                <TraditionalprocessfaqRealtor partner={props.partner} />
              </span>
            </AccordionDetails>
          </Accordion>
          {/* {props?.partner?.url_path === 'cke'?<></>:
          <Accordion
            id="table"
            expanded={(props.efficient !== true ? open8 : true) || (props.efficient !== true ? false : true)}
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={() => {  GAEventTrackerHomeBuyerQue7('FAQs/Questionnaire', 1); setOpen8(!open8 && props.setEfficient(!props.efficient)) }}
              expandIcon={open8 || props.efficient === true ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How does The Trade-In Mortgage™ pricing compare to iBuyers or other buy-first solutions?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium col-12" style={{ textAlign: "justify" }}>
                The Trade-In Mortgage™ costs less than iBuyers and other buy-first products on the market. Below is an in-depth pricing example estimating the fees you would pay for using different home purchase solutions.
                <Tablefaq partner={props.partner}/>
              </span>
            </AccordionDetails>
          </Accordion>} */}
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTrackerHomeBuyerQue8('FAQs/Questionnaire', 1); setOpen9(!open9) }}
              expandIcon={open9 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">What happens if my original house doesn’t sell within the specified timeframe on the open market?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                Our goal is to help you sell your original home for maximum value on the open market. However, Calque provides a back-up plan in case your original home doesn’t sell and close in time. When you first apply for The Trade-In Mortgage™, Calque, will send you a guaranteed backup offer (GBO) stating how much they will pay for your house if it doesn’t sell on the open market within the specified timeframe ({(props?.partner.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? 'up to 150' : (props?.partner?.url_path === 'warburton')?'usually 150':'usually 120'} days in most markets). In the small number of instances when a client’s original home doesn’t sell on the open market, Calque, buys it for the previously agreed-upon GBO.

              </span>
            </AccordionDetails>
          </Accordion>
          {props.partner.faq_home_owner ?
            <Accordion
            >
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
                onClick={(e) => { GAEventTrackerHomeBuyerQue9('FAQs/Questionnaire', 1); setOpen10(!open10) }}
                expandIcon={open10 ? <RemoveIcon /> : <AddSharpIcon />}
              >
                <span className="montserrat-semibold">Are there any limits to the type of property I can buy with The Trade-In Mortgage™?</span>
              </AccordionSummary>
              <AccordionDetails>
                <span className="montserrat-medium">The Trade-In Mortgage™ can be used to buy single family homes, condominiums with Fannie Mae and FHA approval, and townhomes and Planned Urban Developments (i.e., PUDs). All properties are subject to lender approval.</span>
              </AccordionDetails>
            </Accordion>
            :
            ''
          }
        </div>
        : ''}
      {showResultsTwo === true ?
        <div >
          <Accordion
            style={{ borderTop: 'none' }}

          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("What is The Trade-In Mortgage™"); setOpen11(!open11) }}
              expandIcon={open11 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">What is The Trade-In Mortgage™? </span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                The Trade-In Mortgage™ is an innovative loan product that enables current homeowners to buy a new house before selling their existing house. We use a new underwriting process that allows clients to tap into the equity they have in their existing home before their agent even lists it on the open market. This simplifies and streamlines the entire home buying process and reduces stress by allowing clients to submit non-contingent offers as good as cash on new home prospects, buy and move into their new home before they sell their existing one, and make repairs and prep their original home for sale after they have moved out. Our goal is to help consumers buy and sell real estate on their terms, and we look forward to partnering with agents like you to make this a reality.

              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("How does it work"); setOpen12(!open12) }}
              expandIcon={open12 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How does it work?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                The Trade-In Mortgage™ makes the home purchase process more convenient and affordable for consumers and can be broken down into four simple and easy steps:
                <Howitworksrealestatefaq partner={props.partner} />
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("How will it help my clients"); setOpen13(!open13) }}
              expandIcon={open13 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How will it help my clients? </span>
            </AccordionSummary>
            <AccordionDetails style={{ marginLeft: '10px' }}>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                <Myclientfaq />
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("How will it help me"); setOpen14(!open14) }}
              expandIcon={open14 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How will it help me?  </span>
            </AccordionSummary>
            <AccordionDetails style={{ marginLeft: '10px' }}>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>

                <Helpmerealestatefaq />
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("How much will The Trade-In Mortgage™ cost me as an agent"); setOpen15(!open15) }}
              expandIcon={open15 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How much will The Trade-In Mortgage™ cost me as an agent?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                Nothing--there are no fees, no commission shares, and no certification requirements for agents who use The Trade-In Mortgage™. Furthermore, we do not interfere in the commission agreement between you and your client.
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("How much more will The Trade-In Mortgage™ cost my clients compared to a traditional mortgage"); setOpen16(!open16) }}
              expandIcon={open16 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How much more will The Trade-In Mortgage™ cost my clients compared to a traditional mortgage? </span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                On average, The Trade-In Mortgage™ costs consumers approximately 1.5% of the purchase price of the new home. Most of the time, you can save your customer more than this with the leverage of a non-contingent offer.

                Furthermore, once your clients have purchased their new home, they will only make mortgage payments on the new home. The Trade-In Mortgage™ will cover their existing mortgage payments on the original home.

              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("How do I get started with The Trade-In Mortgage™ program"); setOpen17(!open17) }}
              expandIcon={open17 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How do I get started with The Trade-In Mortgage™ program? </span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                The Trade-In Mortgage™ requires very little change to the homebuying process for agents because our solution changes the underwriting practices for the lender, not the purchase process itself. Please reach out to your preferred loan officer at our bank to schedule a 20 minute meeting to go over The Trade-In Mortgage™. He or she will be able to answer any preliminary questions you may have. In addition, once you and a client decide to move forward with using The Trade-In Mortgage™, we guarantee that your loan officer will be available for additional meetings and provide extra support throughout the entire process to ensure it goes smoothly for you and your client.
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("How does my client request The Trade-In Mortgage™"); setOpen18(!open18) }}
              expandIcon={open18 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How does my client request The Trade-In Mortgage™?   </span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                Please direct your client to our website where they will click on “Get Started.” The initial information they need to fill out to start their questionnaire should take less than 5 minutes to complete.
              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("What do I need to do differently as an agent if my client uses The Trade-In Mortgage™"); setOpen19(!open19) }}
              expandIcon={open19 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">What do I need to do differently as an agent if my client uses The Trade-In Mortgage™? </span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                The Trade-In Mortgage™ requires little change to the home-buying process for agents because our solution changes the lending practices, not the purchase process. The only difference you will experience is if you aren’t able to sell your client’s original home on the open market within the specified time frame of the Guaranteed Backup Offer (GBO) (usually {(props?.partner.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? '150' : '120'} days in most markets), then Calque will buy the home at the agreed-upon GBO. Some agents like to keep this in mind when designing a pricing strategy for the original home, much the way you would if a client had a specific deadline for a sale.
              </span>
            </AccordionDetails>
          </Accordion>
          {/* <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("How does The Trade-In Mortgage™ compare to iBuyers and other buy-first solutions"); setOpen20(!open20) }}
              expandIcon={open20 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">How does The Trade-In Mortgage™ compare to iBuyers and other buy-first solutions?  </span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium col-12" style={{ textAlign: "justify" }}>
                We want to make The Trade-In Mortgage™ as easy and hassle-free as we can for all parties involved. This means that you don’t have to get certified to work with us or sign an exclusivity agreement like you do with other buy-first solutions. In addition, our fee structure is transparent, and The Trade-In Mortgage™ costs your clients less than other home purchase solutions on the market.

                Below is an in-depth pricing example estimating fees for using different home purchase solutions.
                <Tablerealestatefaq partner={props.partner} />
              </span>
            </AccordionDetails>
          </Accordion> */}
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("Do I need to worry about RESPA or any other compliance issues"); setOpen21(!open21) }}
              expandIcon={open21 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">Do I need to worry about RESPA or any other compliance issues?</span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                No, we’ve specifically addressed pricing and evaluated this offering with legal counsel to make sure that we have a fully compliant offering.

              </span>
            </AccordionDetails>
          </Accordion>
          <Accordion
          >
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
              onClick={(e) => { GAEventTracker("What happens if my client’s original home doesn’t sell within the specified timeframe"); setOpen22(!open22) }}
              expandIcon={open22 ? <RemoveIcon /> : <AddSharpIcon />}
            >
              <span className="montserrat-semibold">What happens if my client’s original home doesn’t sell within the specified timeframe? </span>
            </AccordionSummary>
            <AccordionDetails>
              <span className="montserrat-medium" style={{ textAlign: "justify" }}>
                Our goal is to empower you and your client to sell the original home for maximum value on the open market. However, we provide a back-up plan to help when a home doesn’t sell in time.
                When your client first applies for The Trade-In Mortgage™, our partner, Calque, will send them a guaranteed backup offer (GBO) stating how much Calque will pay for their house if it doesn’t sell within the specified timeframe (usually {(props?.partner.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? '150' : '120'} days in most markets). In the small number of instances when a client’s house doesn’t sell on the open market, our partner, Calque, buys it for the previously agreed-upon GBO, which is usually at least 90% of the appraised value of the house.
                We never interfere in the commission agreement between you and your client. However, in the event that Calque buys the home at the GBO, agents and clients may choose to agree on a reduced commission. If you choose to reduce your commission in the event of a sale to Calque, our buyer will match your reduction in commission. For example, if you reduce your commission from 3% to 1%, then our buyer’s agent will reduce their commission from 3% to 1%.

              </span>
            </AccordionDetails>
          </Accordion>
          {props.partner.faq_real_estate ?
            <Accordion
            >
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
                onClick={(e) => { GAEventTracker("Are there any limits to the type of property my client can buy with The Trade-In Mortgage™"); setOpen23(!open23) }}
                expandIcon={open23 ? <RemoveIcon /> : <AddSharpIcon />}
              >
                <span className="montserrat-semibold">Are there any limits to the type of property my client can buy with The Trade-In Mortgage™?</span>
              </AccordionSummary>
              <AccordionDetails>
                <span className="montserrat-medium">The Trade-In Mortgage™ can be used to buy single family homes, condominiums with Fannie Mae and FHA approval, and townhomes and Planned Urban Developments (i.e., PUDs). All properties are subject to lender approval.</span>
              </AccordionDetails>
            </Accordion>
            :
            ''
          }
        </div>
        : ''}
    </div>
  );
}